import { TabId } from '../types';
import { getTabPanels } from '../utils';
import { useMemo } from 'react';

/**
 * Returns an array of tab ids that can be selected
 * @param children should include "TabPanel" components on the first level of nesting
 */
export const useAvailableTabIds = (children): TabId[] =>
	useMemo(() => {
		const tabPanels = getTabPanels(children);

		return tabPanels.map((tab) => tab.props.id);
	}, [children]);
